import axios from "axios";

export const createBlogAPICall = async (blogFeed, setMessage) => {
  try {
    const res = await axios.post("https://sumail-code.onrender.com/api/v1/blogs", blogFeed);
    setMessage(`Blog created with id: ${res.data.data.blog._id}`);
  } catch (err) {
    console.log(err);
  }
};
